// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3nNTO","options":"AnswerScale_options__2RS14","selected":"AnswerScale_selected__3c_V1"};